<template>
  <v-row class="pt-5 mb-3 mx-0">
    <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
      <div class="searchInput">
        <v-text-field 
          color="primarytext" 
          persistent-placeholder 
          :rules="required" 
          @click:clear="clearPartReturn"
          v-model="searchPartKeyLocal" 
          @input="onPartSearch" 
          label="Search Part Number To Receive"
          outlined
          :disabled="disableFlag"
          clearable 
          dense 
          class="ma-0">
        </v-text-field>
        <div v-if="showPartSearchResults" v-bind:class="(this.$vuetify.theme.dark) ? 'darkResultBox' : 'resultBox'">
          <ul>
            
            <li v-for="item in partResults" 
                v-bind:key="item.part_id" 
                @mousedown="selectPart(item)"
                style="padding:2px;">
              <span>
                <b>{{ item.part_num }}</b><br />
                {{ item.part_desc }}<br />
              </span>
            </li>
          </ul>
        </div>
      </div>
    </v-col>
    <!-- Description of Part Number -->
    <v-col cols="12" sm="12" md="12" lg="4" class="px-5 py-0">
      <b>{{ selectedPart.order_line[0].return_part_number }}</b><br />
      {{ selectedPart.order_line[0].return_part_description }}<br />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'PartSearchComp',
  props: {
    required: {
      type: Array,
      default: () => []
    },
    disableFlag: {
      type: Boolean,
      default: false
    },
    selectedPart: {
      type: Object,
      default: () => ({
        part_num: '',
        part_desc: ''
      })
    },
    searchPartKey: {
      type: String,
      default: ''
    },
    showPartRetDetails: {
      type: Boolean,
      default: false
    },
    returnResultList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchPartKeyLocal: this.searchPartKey,
      showPartSearchResults: this.showPartRetDetails,
      partResults: this.returnResultList
    }
  },
  watch: {
    searchPartKey(newVal) {
      this.searchPartKeyLocal = newVal;
    },
    showPartRetDetails(newVal) {
      this.showPartSearchResults = newVal;
    },
    returnResultList(newVal) {
      this.partResults = newVal;
    }
  },
  methods: {
    clearPartReturn() {
      this.$emit('clear-part-return');
    },
    onPartSearch() {
      this.$emit('search-part', this.searchPartKeyLocal);
    },
    selectPart(item) {
      this.$emit('select-part', item);
      this.searchPartKeyLocal = item.part_num;
    }
  }
}
</script>

